(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const setup = () => {
    document.querySelectorAll('.product__info-container').forEach(info => {
      const quantity = info.querySelector('.product-form__quantity');
      const buttons = info.querySelector('product-form .product-form__buttons');
      const submit = buttons?.querySelector('.product-form__submit');
      if (quantity && submit) {
        if (mobile.matches && !info.querySelector('.scw-mobile-buy-row')) {
          const marker = document.createElement('span'); marker.className='scw-quantity-position'; quantity.before(marker);
          const row=document.createElement('div'); row.className='scw-mobile-buy-row';submit.before(row);row.append(quantity,submit);
        } else if (!mobile.matches) {
          const row=info.querySelector('.scw-mobile-buy-row'), marker=info.querySelector('.scw-quantity-position');
          if(row&&marker){marker.replaceWith(quantity);row.before(submit);row.remove();}
        }
      }
      const research=info.querySelector('[data-scw-product-research]');
      const delivery=info.querySelector('.scw-delivery-joined');
      if(research && delivery){
        if(mobile.matches && !info.querySelector('.scw-research-position')){
          const marker=document.createElement('span');marker.className='scw-research-position';marker.hidden=true;research.before(marker);delivery.before(research);
        }else if(!mobile.matches){
          const marker=info.querySelector('.scw-research-position');if(marker)marker.replaceWith(research);
        }
      }
      info.querySelectorAll('.scw-product-research__panel--rookies').forEach(panel=>{
        const existing=panel.querySelector('details.scw-rookie-details');
        if(mobile.matches&&!existing){
          const heading=panel.querySelector('.scw-product-research__heading');
          if(!heading)return;
          const details=document.createElement('details');details.className='scw-rookie-details';details.open=false;
          const summary=document.createElement('summary');summary.textContent='Key Rookies To Chase';details.append(summary);
          heading.hidden=true;
          const textField=panel.querySelector('.metafield-multi_line_text_field');
          if(textField&&!panel.querySelector('.scw-rookie-tags')){
            const names=textField.innerHTML.split(/<br\s*\/?\s*>/i).map(part=>{const el=document.createElement('span');el.innerHTML=part;return el.textContent.trim();}).filter(Boolean);
            const list=document.createElement('ul');list.className='scw-rookie-tags';names.forEach(name=>{const li=document.createElement('li');li.textContent=name;list.append(li)});textField.hidden=true;textField.after(list);
          }

          [...panel.children].filter(el=>el!==heading).forEach(el=>details.append(el));
          
          panel.append(details);
        }else if(!mobile.matches&&existing){
          [...existing.children].filter(el=>el.tagName!=='SUMMARY').forEach(el=>panel.append(el));existing.remove();
          const heading=panel.querySelector('.scw-product-research__heading');if(heading)heading.hidden=false;
          panel.querySelector('.scw-rookie-tags')?.remove();panel.querySelector('.scw-added-note')?.remove();const field=panel.querySelector('.metafield-multi_line_text_field');if(field)field.hidden=false;
        }
      });
    });
  };
  let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;setup();});};
  setup();mobile.addEventListener('change',schedule);
  document.querySelectorAll('[data-scw-product-research]').forEach(root=>new MutationObserver(schedule).observe(root,{childList:true,subtree:true}));
  document.addEventListener('shopify:section:load',schedule);
})();
